const city = [
  { vkey: '620100', value: '兰州市' },
  { vkey: '620200', value: '嘉峪关市' },
  { vkey: '620300', value: '金昌市' },
  { vkey: '620400', value: '白银市' },
  { vkey: '620500', value: '天水市' },
  { vkey: '620600', value: '武威市' },
  { vkey: '620700', value: '张掖市' },
  { vkey: '620800', value: '平凉市' },
  { vkey: '620900', value: '酒泉市' },
  { vkey: '621000', value: '庆阳市' },
  { vkey: '621100', value: '定西市' },
  { vkey: '621200', value: '陇南市' },
  { vkey: '621500', value: '兰州新区' },
  { vkey: '622900', value: '临夏回族自治州' },
  { vkey: '623000', value: '甘南藏族自治州' }
]
export const otherDic = {
  cityName: city,
  projectType: [
    { vkey: '1', value: '省列重大项目' },
    { vkey: '2', value: '全省重点项目' },
    { vkey: '3', value: '绿色项目' },
    // { vkey: '4', value: '补短板项目' },
    { vkey: '5', value: '全省重大前期项目' },
    { vkey: '6', value: '投资项目在线审批平台项目' },
    { vkey: '7', value: '制造业中长期贷款项目' }
  ],
  industryName: [
    { vkey: '农、林、牧、渔业', value: '农、林、牧、渔业' },
    { vkey: '采矿业', value: '采矿业' },
    { vkey: '制造业', value: '制造业' },
    {
      vkey: '电力、热力、燃气及水生产和供应业',
      value: '电力、热力、燃气及水生产和供应业'
    },
    { vkey: '建筑业', value: '建筑业' },
    { vkey: '批发和零售业', value: '批发和零售业' },
    { vkey: '交通运输、仓储和邮政业', value: '交通运输、仓储和邮政业' },
    { vkey: '住宿和餐饮业', value: '住宿和餐饮业' },
    {
      vkey: '信息传输、软件和信息技术服务业',
      value: '信息传输、软件和信息技术服务业'
    },
    { vkey: '金融业', value: '金融业' },
    { vkey: '房地产业', value: '房地产业' },
    { vkey: '租赁和商务服务业', value: '租赁和商务服务业' },
    { vkey: '科学研究和技术服务业', value: '科学研究和技术服务业' },
    { vkey: '水利、环境和公共设施管理业', value: '水利、环境和公共设施管理业' },
    { vkey: '居民服务、修理和其他服务业', value: '居民服务、修理和其他服务业' },
    { vkey: '教育', value: '教育' },
    { vkey: '卫生和社会工作', value: '卫生和社会工作' },
    { vkey: '文化、体育和娱乐业', value: '文化、体育和娱乐业' },
    {
      vkey: '公共管理、社会保障和社会组织',
      value: '公共管理、社会保障和社会组织'
    },
    { vkey: '国际组织', value: '国际组织' },
    { vkey: '其它', value: '其它' }
  ],
  areaDetailName: city
}

export const substationList = [
  {
    id: '6201',
    name: '兰州市',
    path: 'lanzhou',
    children: [
      {
        id: '620102',
        name: '城关区',
        path: 'chengguan',
        parentPath: 'subplatform'
      },
      {
        id: '620103',
        name: '七里河区',
        path: 'qilihe',
        parentPath: 'subplatform'
      },
      {
        id: '620104',
        name: '西固区',
        path: 'xigu',
        parentPath: 'subplatform'
      },
      {
        id: '620105',
        name: '安宁区',
        path: 'anning',
        parentPath: 'subplatform'
      },
      {
        id: '620111',
        name: '红古区',
        path: 'honggu',
        parentPath: 'subplatform'
      },
      {
        id: '620121',
        name: '永登县',
        path: 'yongdeng',
        parentPath: 'subplatform'
      },
      {
        id: '620122',
        name: '皋兰县',
        path: 'gaolan',
        parentPath: 'subplatform'
      },
      {
        id: '620123',
        name: '榆中县',
        path: 'yuzhong',
        parentPath: 'subplatform'
      }
    ]
  },

  {
    id: '6202',
    name: '嘉峪关市',
    path: 'jiayuguan'
  },
  {
    id: '6203',
    name: '金昌市',
    path: 'jinchang',
    children: [
      {
        id: '620302',
        name: '金川区',
        path: 'jinchuan',
        parentPath: 'subplatform'
      },
      {
        id: '620321',
        name: '永昌县',
        path: 'yongchang',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6204',
    name: '白银市',
    path: 'baiyin',
    children: [
      {
        id: '620402',
        name: '白银区',
        path: 'baiyinqu',
        parentPath: 'subplatform'
      },
      {
        id: '620403',
        name: '平川区',
        path: 'pingchuan',
        parentPath: 'subplatform'
      },
      {
        id: '620422',
        name: '会宁县',
        path: 'huining',
        parentPath: 'subplatform'
      },
      {
        id: '620421',
        name: '靖远县',
        path: 'jingyuan',
        parentPath: 'subplatform'
      },
      {
        id: '620423',
        name: '景泰县',
        path: 'jingtiai',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6205',
    name: '天水市',
    path: 'tianshui',
    children: [
      {
        id: '620502',
        name: '秦州区',
        path: 'qinzhou',
        parentPath: 'subplatform'
      },
      {
        id: '620503',
        name: '麦积区',
        path: 'maiji',
        parentPath: 'subplatform'
      },
      {
        id: '620521',
        name: '清水县',
        path: 'qingshui',
        parentPath: 'subplatform'
      },
      {
        id: '620522',
        name: '秦安县',
        path: 'qinan',
        parentPath: 'subplatform'
      },
      {
        id: '620523',
        name: '甘谷县',
        path: 'gangu',
        parentPath: 'subplatform'
      },
      {
        id: '620524',
        name: '武山县',
        path: 'wushan',
        parentPath: 'subplatform'
      },
      {
        id: '620525',
        name: '张家川回族自治县',
        path: 'zhangjiachuan',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6206',
    name: '武威市',
    path: 'wuwei',
    children: [
      {
        path: 'liangzhou',
        id: '620602',
        name: '凉州区',
        parentPath: 'subplatform'
      },
      {
        path: 'tianzhu',
        id: '620623',
        name: '天祝藏族自治县',
        parentPath: 'subplatform'
      },
      {
        path: 'minqin',
        id: '620621',
        name: '民勤县',
        parentPath: 'subplatform'
      },
      {
        path: 'gulang',
        id: '620622',
        name: '古浪县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6207',
    name: '张掖市',
    path: 'zhangye',
    children: [
      {
        id: '620902',
        name: '甘州区',
        path: '620702',
        parentPath: 'subplatform'
      },
      {
        id: '620721',
        name: '肃南裕固族自治县',
        path: 'sunan',
        parentPath: 'subplatform'
      },
      {
        id: '620722',
        name: '民乐县',
        path: 'minle',
        parentPath: 'subplatform'
      },
      {
        id: '620723',
        name: '临泽县',
        path: 'linze',
        parentPath: 'subplatform'
      },
      {
        id: '620724',
        name: '高台县',
        path: 'gaotai',
        parentPath: 'subplatform'
      },
      {
        id: '620725',
        name: '山丹县',
        path: 'shandan',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6208',
    name: '平凉市',
    path: 'pingliang',
    children: [
      {
        path: 'lingtai',
        id: '620822',
        name: '灵台县',
        parentPath: 'subplatform'
      },
      {
        path: 'jingchuan',
        id: '620821',
        name: '泾川县',
        parentPath: 'subplatform'
      },
      {
        path: 'kongdong',
        id: '620802',
        name: '崆峒区',
        parentPath: 'subplatform'
      },
      {
        path: 'zhuanglang',
        id: '620825',
        name: '庄浪县',
        parentPath: 'subplatform'
      },
      {
        path: 'chongxin',
        id: '620823',
        name: '崇信县',
        parentPath: 'subplatform'
      },
      {
        path: 'jingning',
        id: '620826',
        name: '静宁县',
        parentPath: 'subplatform'
      },
      {
        path: 'huating',
        id: '620824',
        name: '华亭县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6209',
    name: '酒泉市',
    path: 'jiuquan',
    children: [
      {
        id: '620902',
        name: '肃州区',
        path: 'suzhou',
        parentPath: 'subplatform'
      },
      {
        id: '620921',
        name: '金塔县',
        path: 'jinta',
        parentPath: 'subplatform'
      },
      {
        id: '620922',
        name: '瓜州县',
        path: 'guazhou',
        parentPath: 'subplatform'
      },
      {
        id: '620923',
        name: '肃北蒙古族自治县',
        path: 'subei',
        parentPath: 'subplatform'
      },
      {
        id: '620924',
        name: '阿克塞哈萨克族自治县',
        path: 'akesai',
        parentPath: 'subplatform'
      },
      {
        id: '620981',
        name: '玉门市',
        path: 'yumen',
        parentPath: 'subplatform'
      },
      {
        id: '620982',
        name: '敦煌市',
        path: 'dunhuang',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6210',
    name: '庆阳市',
    path: 'qingyang',
    children: [
      {
        path: 'xifeng',
        id: '621002',
        name: '西峰区',
        parentPath: 'subplatform'
      },
      {
        path: 'zhenyuan',
        id: '621027',
        name: '镇原县',
        parentPath: 'subplatform'
      },
      {
        path: 'huanxian',
        id: '621022',
        name: '环县',
        parentPath: 'subplatform'
      },
      {
        path: 'qingcheng',
        id: '621021',
        name: '庆城县',
        parentPath: 'subplatform'
      },
      {
        path: 'huachi',
        id: '621023',
        name: '华池县',
        parentPath: 'subplatform'
      },
      {
        path: 'zhengning',
        id: '621025',
        name: '正宁县',
        parentPath: 'subplatform'
      },
      {
        path: 'heshui',
        id: '621024',
        name: '合水县',
        parentPath: 'subplatform'
      },
      {
        path: 'ningxian',
        id: '621026',
        name: '宁县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6211',
    name: '定西市',
    path: 'dingxi',
    children: [
      {
        path: 'longxi',
        id: '621122',
        name: '陇西县',
        parentPath: 'subplatform'
      },
      {
        path: 'anding',
        id: '621102',
        name: '安定区',
        parentPath: 'subplatform'
      },
      {
        path: 'minxian',
        id: '621126',
        name: '岷县',
        parentPath: 'subplatform'
      },
      {
        path: 'weiyuan',
        id: '621123',
        name: '渭源县',
        parentPath: 'subplatform'
      },
      {
        path: 'linzhao',
        id: '621124',
        name: '临洮县',
        parentPath: 'subplatform'
      },
      {
        path: 'zhangxian',
        id: '621125',
        name: '漳县',
        parentPath: 'subplatform'
      },
      {
        path: 'tongwei',
        id: '621121',
        name: '通渭县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6212',
    name: '陇南市',
    path: 'longnan',
    children: [
      {
        path: 'huixian',
        id: '621227',
        name: '徽县',
        parentPath: 'subplatform'
      },
      {
        path: 'wudu',
        id: '621202',
        name: '武都区',
        parentPath: 'subplatform'
      },
      {
        path: 'wenxian',
        id: '621222',
        name: '文县',
        parentPath: 'subplatform'
      },
      {
        path: 'chengxian',
        id: '621221',
        name: '成县',
        parentPath: 'subplatform'
      },
      {
        path: 'kangxian',
        id: '621224',
        name: '康县',
        parentPath: 'subplatform'
      },
      {
        path: 'tanchang',
        id: '621223',
        name: '宕昌县',
        parentPath: 'subplatform'
      },
      {
        path: 'lixian',
        id: '621226',
        name: '礼县',
        parentPath: 'subplatform'
      },
      {
        path: 'xihe',
        id: '621225',
        name: '西和县',
        parentPath: 'subplatform'
      },
      {
        path: 'liangdang',
        id: '621228',
        name: '两当县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6229',
    name: '临夏回族自治州',
    path: 'lxhz',
    children: [
      {
        path: 'linxiaxian',
        id: '622921',
        name: '临夏县',
        parentPath: 'subplatform'
      },
      {
        path: 'linxia',
        id: '622901',
        name: '临夏市',
        parentPath: 'subplatform'
      },
      {
        path: 'hezheng',
        id: '622925',
        name: '和政县',
        parentPath: 'subplatform'
      },
      {
        path: 'kangle',
        id: '622922',
        name: '康乐县',
        parentPath: 'subplatform'
      },
      {
        path: 'dongxiang',
        id: '622926',
        name: '东乡族自治县',
        parentPath: 'subplatform'
      },
      {
        path: 'yongjing',
        id: '622923',
        name: '永靖县',
        parentPath: 'subplatform'
      },
      {
        path: 'guanghe',
        id: '622924',
        name: '广河县',
        parentPath: 'subplatform'
      },
      {
        path: 'jishishan',
        id: '622927',
        name: '积石山保安族东乡族撒拉族自治县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6230',
    name: '甘南藏族自治州',
    path: 'gnzz',
    children: [
      {
        path: 'hezuo',
        id: '623001',
        name: '合作市',
        parentPath: 'subplatform'
      },
      {
        path: 'maqu',
        id: '623025',
        name: '玛曲县',
        parentPath: 'subplatform'
      },
      {
        path: 'zhouqu',
        id: '623023',
        name: '舟曲县',
        parentPath: 'subplatform'
      },
      {
        path: 'zhuoni',
        id: '623022',
        name: '卓尼县',
        parentPath: 'subplatform'
      },
      {
        path: 'xiahe',
        id: '623027',
        name: '夏河县',
        parentPath: 'subplatform'
      },
      {
        path: 'diebu',
        id: '623024',
        name: '迭部县',
        parentPath: 'subplatform'
      },
      {
        path: 'lintan',
        id: '623021',
        name: '临潭县',
        parentPath: 'subplatform'
      },
      {
        path: 'luqu',
        id: '623026',
        name: '碌曲县',
        parentPath: 'subplatform'
      }
    ]
  },
  {
    id: '6215',
    name: '兰州新区',
    path: 'lzxq'
  }
]



// WEBPACK FOOTER //
// ./src/assets/json/data.js